import React from "react";
import "../styles/Home.css";

export default function TermsConditions() {
  return (
    <div>
      <section
        className="terms-wrapper"
        style={{ marginLeft: "32px", marginRight: "32px" }}
      >
        <div className="terms-container">
          <h2 style={{ fontSize: "2.5rem", color: "#39512f" }}>
            Terms and Conditions:
          </h2>
          <p
            className="terms-subtitle"
            style={{ fontSize: "16px", color: "#3e3a35", marginTop: "40px" }}
          >
            <strong>
              The following Terms and Conditions govern your use of the website
              and/or purchase from us:
            </strong>
          </p>
          <p
            className="terms-date"
            style={{ fontSize: "14px", color: "#3e3a35" }}
          >
            Last updated on July 9 2025
          </p>

          <p style={{ fontSize: "14px", color: "#3e3a35" }}>
            For the purpose of these Terms and Conditions, The term "we", "us",
            "our" used anywhere on this page shall mean ALFA SOUTHIN CAFE, whose
            registered/operational office is Shop No 3 and 4, Florina Estate,
            Silver Oak Society, Kalyani Nagar Pune MAHARASHTRA 411014. "you",
            "your", "user", "visitor" shall mean any natural or legal person who
            is visiting our website and/or agreed to purchase from us.
          </p>

          <ul className="terms-list">
            <li style={{ fontSize: "14px", color: "#3e3a35" }} className="pb">
              The content of the pages of this website is subject to change
              without notice.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              Neither we nor any third parties provide any warranty or guarantee
              as to the accuracy, timeliness, performance, completeness or
              suitability of the information and materials found or offered on
              this website for any particular purpose. You acknowledge that such
              information and materials may contain inaccuracies or errors and
              we expressly exclude liability for any such inaccuracies or errors
              to the fullest extent permitted by law.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              Your use of any information or materials on our website and/or
              product pages is entirely at your own risk, for which we shall not
              be liable. It shall be your own responsibility to ensure that any
              products, services or information available through our website
              and/or product pages meet your specific requirements.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              Our website contains material which is owned by or licensed to us.
              This material includes, but is not limited to, the design, layout,
              look, appearance and graphics. Reproduction is prohibited other
              than in accordance with the copyright notice, which forms part of
              these terms and conditions.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              All trademarks reproduced in our website which are not the
              property of, or licensed to, the operator are acknowledged on the
              website.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              Unauthorized use of information provided by us shall give rise to
              a claim for damages and/or be a criminal offense.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              From time to time our website may also include links to other
              websites. These links are provided for your convenience to provide
              further information.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              You may not create a link to our website from another website or
              document without ALFA SOUTHIN CAFE’s prior written consent.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              Any dispute arising out of use of our website and/or purchase with
              us and/or any engagement with us is subject to the laws of India.
            </li>
            <li className="pb" style={{ fontSize: "14px", color: "#3e3a35" }}>
              We, shall be under no liability whatsoever in respect of any loss
              or damage arising directly or indirectly out of the decline of
              authorization for any Transaction, on Account of the Cardholder
              having exceeded the preset limit mutually agreed by us with our
              acquiring bank from time to time.
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}
